import { useContext, useEffect } from 'react'

import { useElements, useStripe } from '@stripe/react-stripe-js'
import { Stripe, StripeElements } from '@stripe/stripe-js'
import { useFormContext } from 'react-hook-form'

import { AppContext } from 'Const'
import useEvent from 'Hooks/useEvent'

import { usePayment } from '../../Provider'

interface StripePayment {
  createPaymentMethod(): void
}

const useStripePayment = (): StripePayment => {
  let stripe: Stripe | null = null
  let elements: StripeElements | null = null
  // TODO: remove try {} made as hotfix
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    stripe = useStripe()
    // eslint-disable-next-line react-hooks/rules-of-hooks
    elements = useElements()
  } catch (error) {
    console.warn(error)
  }
  const { checkout } = useContext(AppContext)
  const { checkout: handleCheckout, setTokenizing } = usePayment()
  const { setValue, setError } = useFormContext()

  const createPaymentMethod = useEvent(() => {
    const create = async () => {
      try {
        if (!stripe || !elements) return

        const { error: elementsError } = await elements.submit()
        if (elementsError) {
          window?.Rollbar?.error(elementsError)
          console.error(elementsError)
          return setError('stripePayment.sourceId', { message: elementsError.message })
        }

        const { error, paymentMethod } = await stripe.createPaymentMethod({ elements })
        if (error) {
          window?.Rollbar?.error(error)
          console.error(error)
          return setError('stripePayment.sourceId', { message: error.message })
        }
        if (paymentMethod) {
          setValue('stripePayment.sourceId', paymentMethod.id)
          void handleCheckout()
        }
      } finally {
        setTokenizing(false)
      }
    }

    void create()
  })

  useEffect(() => {
    if (!stripe || checkout?.payment?.status !== 'requires_action') return

    void stripe.handleNextAction({ clientSecret: checkout.payment.clientSecret }).then(({ error, paymentIntent }) => {
      console.error(error, paymentIntent)
      if (error) return setError('stripePayment.sourceId', { message: error.message })

      void handleCheckout()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkout, stripe])

  return { createPaymentMethod }
}

export default useStripePayment
